import { FaLayerGroup } from "react-icons/fa";
import "./FieldsSection2.css";

const fieldsData = [
  {
    id: "thiet-ke-do-hoa-quang-cao",
    title: "Thiết kế đồ họa quảng cáo",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field1.webp",
  },
  {
    id: "dung-phim-chuyen-nghiep",
    title: "Dựng phim chuyên nghiệp",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field2.webp",
  },
  {
    id: "san-xuat-phim-quang-cao",
    title: "Sản xuất phim quảng cáo",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field3.webp",
  },
  {
    id: "nhiep-anh-va-xu-ly-anh",
    title: "Nhiếp ảnh và xử lý ảnh",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field4.webp",
  },
  {
    id: "thiet-ke-ui-ux",
    title: "Thiết kế UI/UX",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field5.webp",
  },
  {
    id: "hoat-hinh-2d",
    title: "Hoạt hình 2D",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field6.webp",
  },
  {
    id: "thiet-ke-do-hoa-3d",
    title: "Thiết kế đồ họa 3D",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field7.webp",
  },
  {
    id: "tri-tue-nhan-tao-ung-dung",
    title: "Trí tuệ nhân tạo ứng dụng",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field8.webp",
  },
  {
    id: "do-hoa-truyen-hinh",
    title: "Đồ họa truyền hình",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field9.webp",
  },
  {
    id: "do-hoa-kien-truc-noi-that",
    title: "Đồ họa kiến trúc nội thất",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field10.webp",
  },
  {
    id: "hoat-hinh-3d",
    title: "Hoạt hình 3D",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field11.webp",
  },
  {
    id: "thiet-ke-game-3d",
    title: "Thiết kế game 3D",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field12.webp",
  },
  {
    id: "ky-xao-phim-anh",
    title: "Kỹ xảo phim ảnh",
    image: "/images/home/fields/thiet-ke-truyen-thong-maketing/field13.webp",
  },
];

const FieldsSection = () => {
  return (
    <section className="fields--s2">
      <div className="fields__container">
        <div className="fields__icon--s2">
          <FaLayerGroup />
        </div>
        <p className="fields__sub-title--s2">ĐÀO TẠO CHỨNG CHỈ QUỐC GIA</p>
        <h2 className="fields__title--s2">
          Thiết kế - Truyền thông - Maketing
        </h2>

        <div className="fields__cards">
          {fieldsData.map((field) => (
            <div
              key={field.id}
              className="field-card"
              id={field.id}
            >
              <div className="field-card__image">
                <img
                  src={field.image}
                  alt={field.title.replace(/\n/g, " ")}
                  loading="lazy"
                />
              </div>
              <h3 className="field-card__title">
                {field.title.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    {i !== field.title.split("\n").length - 1 && <br />}
                  </span>
                ))}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FieldsSection;
